var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;



//////////////////
// WEBPACK FOOTER
// ./~/_lodash@4.17.4@lodash/_coreJsData.js
// module id = 599
// module chunks = 0 1